module.exports = __webpack_public_path__ + "assets/img/AllBox.dab3f983.png";